import { Api } from "@core/api/api";
import { pageParams } from "@core/api/pageParams";
import { Page, PaginationOptions } from "@utils/page";
import { ExperienceDto, experienceFromDto } from "./dtos";
import { Experience, ExperienceType } from "./experience";
import { ExperienceDraft } from "./experienceDraft";

const EXPERIENCE_URL = "/experiences";

export class ExperienceApi {
	constructor(private api: Api) {}

	async get(id: string): Promise<Experience> {
		const result = await this.api.get<ExperienceDto>(`${EXPERIENCE_URL}/${id}`);
		return experienceFromDto(result.data);
	}

	async getUserExperiences(
		id: string,
		type: ExperienceType,
		pageOptions: PaginationOptions
	): Promise<Page<Experience>> {
		const result = await this.api.get<Page<ExperienceDto>>(
			`${EXPERIENCE_URL}?userId=${id}&type=${type}&${pageParams(pageOptions)}`
		);
		return { ...result.data, content: result.data.content.map((e) => experienceFromDto(e)) };
	}

	async create(draft: ExperienceDraft): Promise<Experience> {
		const result = await this.api.post<ExperienceDto>(EXPERIENCE_URL, draft);
		return experienceFromDto(result.data);
	}

	async save(draft: ExperienceDraft, id: string): Promise<Experience> {
		const result = await this.api.put<ExperienceDto>(`${EXPERIENCE_URL}/${id}`, draft);
		return experienceFromDto(result.data);
	}

	async delete(id: string): Promise<void> {
		return this.api.delete(`${EXPERIENCE_URL}/${id}`);
	}
}
